import React, { useRef } from "react";
import { Input, Label, ComboBox, ComboBoxItem, FlexBox, FlexBoxDirection, Button } from "@ui5/webcomponents-react";

const SocioeconomicForm2 = ({ formData, onFormChange, handlePrevious, handleNext }) => {
  // Define the options with corresponding numbers
  const houseStructureOptions = [
    { value: 1, label: "1 - Duplex" },
    { value: 2, label: "2 - Commercial/Industrial/Agricultural" },
    { value: 3, label: "3 - Extension" },
    { value: 4, label: "4 - Institutional Living Quarters" },
    { value: 5, label: "5 - Multi-unit Residence" },
    { value: 6, label: "6 - Single House" },
    { value: 99, label: "99 - Others, specify" },
  ];

  const externalHouseWallOptions = [
    { value: 1, label: "1 - Asbestos/Glass" },
    { value: 2, label: "2 - Bamboo/Sawali/Cogon/Nipa" },
    { value: 3, label: "3 - Concrete/Brick/Stone" },
    { value: 4, label: "4 - Galvanized Iron/Aluminum" },
    { value: 5, label: "5 - Half-Concrete, Brick, Stone/Half Wood" },
    { value: 6, label: "6 - Makeshift/Salvaged/Improvised" },
    { value: 7, label: "7 - Wood" },
    { value: 8, label: "8 - No Walls" },
    { value: 9, label: "9 - Container Van" },
    { value: 99, label: "99 - Others, specify" },
  ];

  const roofingMatOptions = [
    { value: 1, label: "1 - Bamboo/Sawali/Cogon/Nipa" },
    { value: 2, label: "2 - Galvanized Iron/Aluminum" },
    { value: 3, label: "3 - Makeshift/Salvaged/Improvised" },
    { value: 4, label: "4 - Mixed materials but more of cogon/nipa/anahaw" },
    { value: 5, label: "5 - Mixed materials but more of galvanized iron" },
    { value: 6, label: "6 - Cement" },
    { value: 7, label: "7 - Wood" },
    { value: 8, label: "8 - Mixed materials but more of makeshift/salvaged/improvised" },
    { value: 99, label: "99 - Others, specify" },
  ];

  const floorMatOptions = [
    { value: 1, label: "1 - Bamboo" },
    { value: 2, label: "2 - Cement" },
    { value: 3, label: "3 - Cemented with linoleum" },
    { value: 4, label: "4 - Cemented with tiles" },
    { value: 5, label: "5 - Wood" },
    { value: 6, label: "6 - Soil" },
    { value: 7, label: "7 - Soil with linoleum" },
    { value: 99, label: "99 - Others, specify" },
  ];

  const sourceElectOptions = [
    { value: 1, label: "1 - Electricity" },
    { value: 2, label: "2 - Kerosene (Gaas)" },
    { value: 3, label: "3 - LPG" },
    { value: 4, label: "4 - Battery" },
    { value: 5, label: "5 - Biogas" },
    { value: 6, label: "6 - Solar Energy" },
    { value: 7, label: "7 - Barangay Generator" },
    { value: 8, label: "8 - No Electricity" },
    { value: 99, label: "99 - Others, Specify" },
  ];

  const cookingFacOptions = [
    { value: 1, label: "1 - Electricity" },
    { value: 2, label: "2 - Charcoal" },
    { value: 3, label: "3 - Kerosene (Gaas)" },
    { value: 4, label: "4 - LPG" },
    { value: 5, label: "5 - Wood" },
    { value: 6, label: "6 - Biogas" },
    { value: 99, label: "99 - Others, specify" },
  ];

  // Ownership options (no type here, type is added on selection)
  const ownershipOptions = [
    { value: 1, label: "1 - Pagmamay-ari" },
    { value: 2, label: "2 - Nirentahan" },
    { value: 3, label: "3 - Hinuhulugan" },
    { value: 4, label: "4 - Nagagamit ng libre nang walang pahintulot" },
    { value: 5, label: "5 - Caretaker" },
    { value: 6, label: "6 - Pagmamay-ari ng Pamilya" },
    { value: 7, label: "7 - Pagmamay-ari ng Gobyerno" },
    { value: 8, label: "8 - PNR Lot" },
    { value: 99, label: "99 - Others, specify" },
  ];

  // Helper to validate ComboBox input
  const getOptionValue = (options, label) => options.find(option => option.label === label)?.value || null;

  return (
    <div style={{ padding: "2rem", maxWidth: "1200px", margin: "auto" }}>
      <h2>Step 3: Household Socioeconomic Information (Part 2)</h2>

      {/* B4. Housing Characteristics */}
      <h2>B4. Housing Characteristics</h2>

      {/* a. Lot Ownership */}
      <h3>a. Lot Ownership</h3>
      <Label style={{ fontWeight: "bold", fontSize: "1rem" }}>Select Lot Ownership</Label>
      <ComboBox
        value={
          typeof formData.lotOwnership === "object"
            ? ownershipOptions.find(option => option.value === formData.lotOwnership.value)?.label || ""
            : ownershipOptions.find(
                option =>
                  option.value === formData.lotOwnership ||
                  option.value === Number(formData.lotOwnership)
              )?.label || ""
        }
        onChange={(e) => {
          const selectedValue = ownershipOptions.find(option => option.label === e.target.value)?.value || null;
          if (selectedValue !== null) {
            onFormChange("lotOwnership", { value: selectedValue, type: "LOT_OWNERSHIP" });
          } else {
            onFormChange("lotOwnership", null);
          }
        }}
        style={{ width: "100%", marginBottom: "1rem" }}
      >
        {ownershipOptions.map(option => (
          <ComboBoxItem key={option.value} text={option.label} />
        ))}
      </ComboBox>
      {(formData.lotOwnership?.value === 99 || formData.lotOwnership === 99) && (
        <Input
          name="lotOwnershipOther"
          value={formData.lotOwnershipOther || ""}
          onInput={(e) => onFormChange("lotOwnershipOther", e.target.value.toUpperCase())}
          placeholder="Specify other lot ownership"
          style={{ width: "100%", textTransform: "uppercase" }}
        />
      )}

      {/* b. House Ownership */}
      <h3>b. House Ownership</h3>
      <Label style={{ fontWeight: "bold", fontSize: "1rem" }}>Select House Ownership</Label>
      <ComboBox
        value={
          typeof formData.houseOwnership === "object"
            ? ownershipOptions.find(option => option.value === formData.houseOwnership.value)?.label || ""
            : ownershipOptions.find(
                option =>
                  option.value === formData.houseOwnership ||
                  option.value === Number(formData.houseOwnership)
              )?.label || ""
        }
        onChange={(e) => {
          const selectedValue = ownershipOptions.find(option => option.label === e.target.value)?.value || null;
          if (selectedValue !== null) {
            onFormChange("houseOwnership", { value: selectedValue, type: "HOUSE_OWNERSHIP" });
          } else {
            onFormChange("houseOwnership", null);
          }
        }}
        style={{ width: "100%", marginBottom: "1rem" }}
      >
        {ownershipOptions.map(option => (
          <ComboBoxItem key={option.value} text={option.label} />
        ))}
      </ComboBox>
      {(formData.houseOwnership?.value === 99 || formData.houseOwnership === 99) && (
        <Input
          name="houseOwnershipOther"
          value={formData.houseOwnershipOther || ""}
          onInput={(e) => onFormChange("houseOwnershipOther", e.target.value.toUpperCase())}
          placeholder="Specify other house ownership"
          style={{ width: "100%", textTransform: "uppercase" }}
        />
      )}

      {/* c. House Structure */}
      <h3>c. House Structure (Kaanuyan ng Bahay)</h3>
      <Label style={{ fontWeight: "bold", fontSize: "1rem" }}>Select House Structure</Label>
      <ComboBox
        value={houseStructureOptions.find(option => option.value === formData.houseStructure)?.label || ""}
        onChange={(e) => {
          const selectedValue = getOptionValue(houseStructureOptions, e.target.value);
          if (selectedValue !== null) {
            onFormChange("houseStructure", selectedValue);
          } else {
            onFormChange("houseStructure", null);
          }
        }}
        onInput={(e) => {
          // If input does not match any option, clear
          if (!houseStructureOptions.some(option => option.label === e.target.value)) {
            onFormChange("houseStructure", null);
          }
        }}
        style={{ width: "100%", marginBottom: "1rem" }}
      >
        {houseStructureOptions.map(option => (
          <ComboBoxItem key={option.value} text={option.label} />
        ))}
      </ComboBox>
      {formData.houseStructure === 99 && (
        <Input
          name="houseStructureOther"
          value={formData.houseStructureOther || ""}
          onInput={(e) => onFormChange("houseStructureOther", e.target.value.toUpperCase())}
          placeholder="Specify other house structure"
          style={{ width: "100%", textTransform: "uppercase" }}
        />
      )}

      {/* d. External Housing Walls */}
      <h3>d. External Housing Walls</h3>
      <Label style={{ fontWeight: "bold", fontSize: "1rem" }}>Select External Housing Wall</Label>
      <ComboBox
        value={externalHouseWallOptions.find(option => option.value === formData.externalHouseWall)?.label || ""}
        onChange={(e) => {
          const selectedValue = getOptionValue(externalHouseWallOptions, e.target.value);
          if (selectedValue !== null) {
            onFormChange("externalHouseWall", selectedValue);
          } else {
            onFormChange("externalHouseWall", null);
          }
        }}
        onInput={(e) => {
          if (!externalHouseWallOptions.some(option => option.label === e.target.value)) {
            onFormChange("externalHouseWall", null);
          }
        }}
        style={{ width: "100%", marginBottom: "1rem" }}
      >
        {externalHouseWallOptions.map(option => (
          <ComboBoxItem key={option.value} text={option.label} />
        ))}
      </ComboBox>
      {formData.externalHouseWall === 99 && (
        <Input
          name="externalHouseWallOther"
          value={formData.externalHouseWallOther || ""}
          onInput={(e) => onFormChange("externalHouseWallOther", e.target.value.toUpperCase())}
          placeholder="Specify other external housing walls"
          style={{ width: "100%", textTransform: "uppercase" }}
        />
      )}

      {/* e. Roofing Materials */}
      <h3>e. Roofing Materials</h3>
      <Label style={{ fontWeight: "bold", fontSize: "1rem" }}>Select Roofing Material</Label>
      <ComboBox
        value={roofingMatOptions.find(option => option.value === formData.roofingMat)?.label || ""}
        onChange={(e) => {
          const selectedValue = getOptionValue(roofingMatOptions, e.target.value);
          if (selectedValue !== null) {
            onFormChange("roofingMat", selectedValue);
          } else {
            onFormChange("roofingMat", null);
          }
        }}
        onInput={(e) => {
          if (!roofingMatOptions.some(option => option.label === e.target.value)) {
            onFormChange("roofingMat", null);
          }
        }}
        style={{ width: "100%", marginBottom: "1rem" }}
      >
        {roofingMatOptions.map(option => (
          <ComboBoxItem key={option.value} text={option.label} />
        ))}
      </ComboBox>
      {formData.roofingMat === 99 && (
        <Input
          name="roofingMatOther"
          value={formData.roofingMatOther || ""}
          onInput={(e) => onFormChange("roofingMatOther", e.target.value.toUpperCase())}
          placeholder="Specify other roofing materials"
          style={{ width: "100%", textTransform: "uppercase" }}
        />
      )}

      {/* f. Flooring Material - First Floor */}
      <h3>f. Flooring Material - First Floor</h3>
      <Label style={{ fontWeight: "bold", fontSize: "1rem" }}>Select Flooring Material</Label>
      <ComboBox
        value={floorMatOptions.find(option => option.value === formData.floorMat)?.label || ""}
        onChange={(e) => {
          const selectedValue = getOptionValue(floorMatOptions, e.target.value);
          if (selectedValue !== null) {
            onFormChange("floorMat", selectedValue);
          } else {
            onFormChange("floorMat", null);
          }
        }}
        onInput={(e) => {
          if (!floorMatOptions.some(option => option.label === e.target.value)) {
            onFormChange("floorMat", null);
          }
        }}
        style={{ width: "100%", marginBottom: "1rem" }}
      >
        {floorMatOptions.map(option => (
          <ComboBoxItem key={option.value} text={option.label} />
        ))}
      </ComboBox>
      {formData.floorMat === 99 && (
        <Input
          name="floorMatOther"
          value={formData.floorMatOther || ""}
          onInput={(e) => onFormChange("floorMatOther", e.target.value.toUpperCase())}
          placeholder="Specify other flooring material"
          style={{ width: "100%", textTransform: "uppercase" }}
        />
      )}

      {/* g. Source of Electricity/Energy */}
      <h3>g. Source of Electricity/Energy</h3>
      <Label style={{ fontWeight: "bold", fontSize: "1rem" }}>Select Source of Electricity</Label>
      <ComboBox
        value={sourceElectOptions.find(option => option.value === formData.sourceElect)?.label || ""}
        onChange={(e) => {
          const selectedValue = getOptionValue(sourceElectOptions, e.target.value);
          if (selectedValue !== null) {
            onFormChange("sourceElect", selectedValue);
          } else {
            onFormChange("sourceElect", null);
          }
        }}
        onInput={(e) => {
          if (!sourceElectOptions.some(option => option.label === e.target.value)) {
            onFormChange("sourceElect", null);
          }
        }}
        style={{ width: "100%", marginBottom: "1rem" }}
      >
        {sourceElectOptions.map(option => (
          <ComboBoxItem key={option.value} text={option.label} />
        ))}
      </ComboBox>
      {formData.sourceElect === 99 && (
        <Input
          name="sourceElectOther"
          value={formData.sourceElectOther || ""}
          onInput={(e) => onFormChange("sourceElectOther", e.target.value.toUpperCase())}
          placeholder="Specify other source of electricity"
          style={{ width: "100%", textTransform: "uppercase" }}
        />
      )}

      {/* h. Cooking Facilities */}
      <h3>h. Cooking Facilities</h3>
      <Label style={{ fontWeight: "bold", fontSize: "1rem" }}>Select Cooking Facility</Label>
      <ComboBox
        value={cookingFacOptions.find(option => option.value === formData.cookingFac)?.label || ""}
        onChange={(e) => {
          const selectedValue = getOptionValue(cookingFacOptions, e.target.value);
          if (selectedValue !== null) {
            onFormChange("cookingFac", selectedValue);
          } else {
            onFormChange("cookingFac", null);
          }
        }}
        onInput={(e) => {
          if (!cookingFacOptions.some(option => option.label === e.target.value)) {
            onFormChange("cookingFac", null);
          }
        }}
        style={{ width: "100%", marginBottom: "1rem" }}
      >
        {cookingFacOptions.map(option => (
          <ComboBoxItem key={option.value} text={option.label} />
        ))}
      </ComboBox>
      {formData.cookingFac === 99 && (
        <Input
          name="cookingFacOther"
          value={formData.cookingFacOther || ""}
          onInput={(e) => onFormChange("cookingFacOther", e.target.value.toUpperCase())}
          placeholder="Specify other cooking facilities"
          style={{ width: "100%", textTransform: "uppercase" }}
        />
      )}
    </div>
  );
};

export default SocioeconomicForm2;